import api from "../api/axiosInstance";

export const fetchPaymentUsers = async () => {
  try {
    const response = await api.get(`/payment/users`);
    return response.data;
  } catch (error) {
    console.error("Error fetching payment users:", error);
    throw error;
  }
};

export const createPaymentUser = async (paymentUserData) => {
  try {
    const response = await api.post(`/payment/add-payment`, paymentUserData);
    return response.data;
  } catch (error) {
    console.error("Error creating payment user:", error);
    throw error;
  }
};

export const updatePaymentUser = async (id, paymentUserData) => {
  try {
    const response = await api.put(`/payment/update-payment-status`, paymentUserData);
    return response.data;
  } catch (error) {
    console.error("Error updating payment user:", error);
    throw error;
  }
};

export const deletePaymentUser = async (id) => {
  try {
    const response = await api.delete(`/payment/delete/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting payment user:", error);
    throw error;
  }
};
